import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { PortalFactoryHome, PORTAL_CREATE_ROOT, PORTAL_REGISTRY_ROOT } from './olivium/portal-factory'

/**
 * Olivium Project Portal Factory — home route wrapper.
 *
 * Registered standalone + auth-gated (see router.tsx):
 *   /square/command-center/olivium/portal-factory
 *
 * The factory landing (template gallery + module catalog + entry points).
 * Presentational; this wrapper only wires navigation. Selecting a template
 * jumps into the create flow with ?template= preselected.
 */
export default function SquareCodePortalFactoryRoute() {
  const navigate = useNavigate()
  return (
    <PortalFactoryHome
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
      onCreatePortal={() => navigate(PORTAL_CREATE_ROOT)}
      onOpenRegistry={() => navigate(PORTAL_REGISTRY_ROOT)}
      onSelectTemplate={(key) => navigate(`${PORTAL_CREATE_ROOT}?template=${encodeURIComponent(key)}`)}
    />
  )
}
